import { ArrowDown } from "lucide-react";
import { LANDING } from "@/constants/testIds";

const CHEF_IMG = "/images/kristy-chef.jpg";
const ACCENT_STRIP =
  "https://images.unsplash.com/photo-1720044332118-3c4741abb0de?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwxfHxiYWhhbWFzJTIwYmVhY2glMjBvY2VhbiUyMGFlcmlhbHxlbnwwfHx8fDE3ODI5MTU1Mjh8MA&ixlib=rb-4.1.0&q=85";

export default function Hero() {
  const scrollTo = (id) =>
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <section
      id="hero"
      className="relative min-h-screen w-full bg-[#F4F1EA] overflow-hidden"
    >
      <div className="relative z-10 min-h-screen grid grid-cols-1 lg:grid-cols-12">
        {/* LEFT — editorial */}
        <div className="lg:col-span-5 order-2 lg:order-1 flex flex-col justify-between px-6 md:px-10 lg:px-14 pt-10 lg:pt-32 pb-14">
          <div>
            <div className="reveal flex items-center gap-3 mb-6">
              <span className="h-px w-10 bg-[#C05A44]" />
              <span className="font-mono-editorial text-[11px] text-[#C05A44]">
                EST. NASSAU · THE BAHAMAS
              </span>
            </div>

            <h1
              className="reveal font-display font-light text-[#1A2B3C] leading-[0.92] tracking-tighter text-6xl sm:text-7xl md:text-8xl lg:text-[7.2rem] xl:text-[8.4rem]"
              style={{ transitionDelay: "80ms" }}
            >
              Kristy
              <br />
              <span className="italic font-normal">Worrell</span>
            </h1>

            <p
              className="reveal font-body text-[#5C6B7A] mt-8 max-w-md text-base md:text-lg leading-relaxed"
              style={{ transitionDelay: "180ms" }}
            >
              Bespoke culinary experiences on the islands — island-inspired
              private dinners, intimate catering, and Bahamian flavor crafted
              around your table.
            </p>

            <div
              className="reveal mt-10 flex flex-wrap items-center gap-4"
              style={{ transitionDelay: "260ms" }}
            >
              <button
                data-testid={LANDING.heroBookBtn}
                onClick={() => scrollTo("contact")}
                className="btn-primary font-body text-xs tracking-[0.24em] uppercase px-8 py-4 bg-[#C05A44] text-[#F4F1EA] hover:bg-[#a94b37]"
              >
                Book the Chef
              </button>
              <button
                data-testid="hero-services-btn"
                onClick={() => scrollTo("services")}
                className="btn-primary font-body text-xs tracking-[0.24em] uppercase px-8 py-4 border border-[#1A2B3C] text-[#1A2B3C] hover:bg-[#1A2B3C] hover:text-[#F4F1EA]"
              >
                Explore Services
              </button>
            </div>
          </div>

          {/* Ocean accent strip at the bottom of left col */}
          <div className="reveal mt-14 hidden lg:flex items-center gap-5" style={{ transitionDelay: "360ms" }}>
            <div
              className="h-14 w-40 bg-cover bg-center grain relative"
              style={{ backgroundImage: `url(${ACCENT_STRIP})` }}
            />
            <div className="font-mono-editorial text-[10px] text-[#5C6B7A] leading-relaxed">
              PERSONAL CHEF · CATERING
              <br />
              <span className="text-[#C05A44]">SERVING ALL 700+ ISLANDS</span>
            </div>
          </div>

          <button
            data-testid={LANDING.heroScrollHint}
            onClick={() => scrollTo("about")}
            className="hidden lg:flex items-center gap-2 text-[#1A2B3C] font-mono-editorial text-[10px] mt-8"
          >
            <span>SCROLL</span>
            <ArrowDown size={14} className="animate-bounce" />
          </button>
        </div>

        {/* RIGHT — chef portrait */}
        <div className="lg:col-span-7 order-1 lg:order-2 relative min-h-[70vh] lg:min-h-screen bg-[#4A5D4E]">
          <img
            src={CHEF_IMG}
            alt="Chef Kristy Worrell smiling in her chef's jacket"
            className="reveal absolute top-24 lg:top-28 left-0 right-0 bottom-0 w-full object-cover"
            style={{
              transitionDelay: "40ms",
              objectPosition: "center top",
              imageRendering: "auto",
              height: "auto",
            }}
            decoding="async"
            fetchpriority="high"
          />
        </div>
      </div>
    </section>
  );
}
